/**
 * @generated SignedSource<<89fe0124b30e5b0b34f6092074680c12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssignUserCouponInput = {
  assignedBy?: string | null | undefined;
  couponOldId: string;
  userId?: string | null | undefined;
  userOldId: string;
};
export type useUserCouponMutationsAssignMutation$variables = {
  input: AssignUserCouponInput;
};
export type useUserCouponMutationsAssignMutation$data = {
  readonly assignUserCoupon: {
    readonly errors: ReadonlyArray<{
      readonly code: string | null | undefined;
      readonly fields: ReadonlyArray<string> | null | undefined;
      readonly message: string | null | undefined;
      readonly shortMessage: string | null | undefined;
      readonly vars: any | null | undefined;
    }>;
    readonly result: {
      readonly assignedBy: string | null | undefined;
      readonly couponOldId: string;
      readonly created: any | null | undefined;
      readonly id: string;
      readonly removedOn: any | null | undefined;
      readonly timesUsed: number | null | undefined;
      readonly userId: string | null | undefined;
      readonly userOldId: string;
    } | null | undefined;
  };
};
export type useUserCouponMutationsAssignMutation = {
  response: useUserCouponMutationsAssignMutation$data;
  variables: useUserCouponMutationsAssignMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AssignUserCouponResult",
    "kind": "LinkedField",
    "name": "assignUserCoupon",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserCoupon",
        "kind": "LinkedField",
        "name": "result",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assignedBy",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "couponOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userOldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "created",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timesUsed",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "removedOn",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "fields",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "shortMessage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vars",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserCouponMutationsAssignMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUserCouponMutationsAssignMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "23f12ef6ace8cdecef77461538e643cf",
    "id": null,
    "metadata": {},
    "name": "useUserCouponMutationsAssignMutation",
    "operationKind": "mutation",
    "text": "mutation useUserCouponMutationsAssignMutation(\n  $input: AssignUserCouponInput!\n) {\n  assignUserCoupon(input: $input) {\n    result {\n      id\n      assignedBy\n      couponOldId\n      userOldId\n      userId\n      created\n      timesUsed\n      removedOn\n    }\n    errors {\n      message\n      fields\n      code\n      shortMessage\n      vars\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3c9844abd56c65b4f758f427552e384";

export default node;
